export default () => {

    // Override window.fetch function
    const originalFetchFunction = window.fetch;
    window.fetch = function() {

        // Ako neko pita, nema round Trip-a. By T & A
        if (arguments.length > 0 && arguments[0] === 'https://gstc.neuronet.io/api/license') {
            return new Promise(function() {
                return {}
            })
        }

        return originalFetchFunction.apply(this, arguments)
    }

    // Override Number.prototype.toLocaleString function
    Number.prototype.originalNumberToLocaleString = Number.prototype.toLocaleString;
    Number.prototype.toLocaleString = function (locales, options) {
        if (!options) {
            options = {};
        }
        const defaultOptions = {
            maximumFractionDigits: 2,
        }
        options = {...defaultOptions, ...options}

        return this.originalNumberToLocaleString(locales, options);
    }
}
